
import { Settings } from "lucide-react";

/**
 * ColumnSettings — Dropdown
 * props:
 *  - columns: [{key,name,isVisible}]
 *  - onToggle(key)
 *  - isOpen, onToggleOpen()
 */
export default function ColumnSettings({ columns, onToggle, isOpen, onToggleOpen }) {
  const visibleCount = columns.filter((c) => c.isVisible).length;

  return (
    <div className="d-flex justify-content-end position-relative">
      <button className="btn btn-light btn-sm d-flex align-items-center" onClick={onToggleOpen}>
        <Settings size={16} className="me-2" />
        <span>Display Col ({visibleCount}/{columns.length})</span>
      </button>

      {isOpen && (
        <div
          className="dropdown-menu d-block p-3 shadow-lg rounded-3"
          style={{ position: "absolute", top: "100%", left: 0, zIndex: 1000, minWidth: "250px" }}
        >
          <p className="fw-bold mb-2">display Col</p>
          {columns.map((col) => (
            <div className="form-check" key={col.key}>
              <input
                className="form-check-input"
                type="checkbox"
                id={`check-${col.key}`}
                checked={col.isVisible}
                onChange={() => onToggle(col.key)}
              />
              <label className="form-check-label" htmlFor={`check-${col.key}`}>
                {col.name}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

